import { Injectable, inject } from '@angular/core';
import { AnalyticsService } from '../analytics/analytics.service';
import { ApiResponseBootup, WagerApi } from 'src/app/core/api/wager-api';
import { environment } from 'src/environments/environment';
import { EventName } from '../analytics/event-names';
import { HttpService } from '../http/http.service';

@Injectable({
  providedIn: 'root',
})
export class BootupService {
  private httpService = inject(HttpService);
  private analyticsService = inject(AnalyticsService);
  private bootupData: ApiResponseBootup | undefined;

  async initialise() {
    this.bootupData = await WagerApi.request(this.httpService).bootup();
    this.analyticsService.log(EventName.BootupRequestSuccess);

    const minWidgetVersion =
      environment.deployment === 'inhouse'
        ? (this.bootupData.minInHouseWidgetVersion ?? 0)
        : (this.bootupData.minOperatorWidgetVersion ?? 0);
    if (minWidgetVersion > environment.build) {
      location.reload();
    }
  }
}
